import * as React from "react";
import { css } from "@emotion/react";
import { StarRating } from "main/javascripts/components/StarRating/StarRating";
import {
  fontSize,
  lineHeight,
} from "main/javascripts/styles/base/typographyStyle";
import { space } from "main/javascripts/styles/base/spaceStyle";
import { textColor } from "main/javascripts/styles/base/colorStyle";

export interface IProps {
  rating: number;
}

export const StarNumRating: React.FC<IProps> = (
  props: IProps
): React.ReactElement | null => {
  const { rating, ...rest } = props;
  if (rating === 0) {
    return null;
  }
  return (
    <div css={blockStyle} {...rest}>
      <StarRating rating={rating} />
      <div css={numStyle}>{rating}</div>
    </div>
  );
};

const blockStyle = css`
  position: relative;
  font-size: ${fontSize.body};
  display: flex;
  align-items: center;
`;
const numStyle = css`
  font-size: ${fontSize.caption};
  line-height: ${lineHeight.noSpace};
  color: ${textColor.secondaryDarkColor};
  display: inline-block;
  vertical-align: middle;
  padding: 0 0 0 ${space.atom0_5x};
  letter-spacing: 0.05em;
`;
